<template>
	<div id="app">
		<Header />
		<Content />
		<Footer />
	</div>
</template>

<script>
export default {
	name: "App",
	components: { 
		Header: () => import(/* webpackChunkName: "Header" */ "./components/template/Header"), 
		Content: () => import(/* webpackChunkName: "Content" */ "./components/template/Content"),  
		Footer: () => import(/* webpackChunkName: "Footer" */ "./components/template/Footer"),  
	}
}
</script>

<style>
	* {
		box-sizing: border-box;
	}
	html, body {
		margin: 0;
		width: 100%;
		height: 100vh;
		background: #2e2d2c !important;
	}

	#app {
		-webkit-font-smothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		min-height: 100%;
		min-width: 300px;
		max-width: 1920px;
		margin:0 auto;
		overflow-x: hidden;
		display: grid;
		grid-template-rows: auto 1fr auto;
		grid-template-columns: 100%;
		grid-template-areas:
			"header"
			"content"
			"footer"
	}
</style>